module.exports = __webpack_public_path__ + "static/media/YF44_0.686bdae7.jpg";